'use client';
import * as Switch from '@radix-ui/react-switch';
import HoverTooltipText from './hover-tooltip-text';

type ToggleSwitchProps = {
    label?: string;
    customClass?: string;
    customLabelClass?: string;
    checked?: boolean;
    tooltipText?: string;
    onCheckedChange?: (checked: boolean) => void;
};

export default function ToggleSwitch({
    label,
    customClass,
    checked,
    onCheckedChange,
    tooltipText,
    customLabelClass,
}: ToggleSwitchProps) {
    return (
        <div className={`${customClass} flex gap-4 cursor-pointer items-start`}>
            <Switch.Root
                className="w-[43px] h-[26px] bg-gray-400 rounded-full relative data-[state=checked]:bg-[#DD06AE] cursor-pointer"
                checked={checked}
                onCheckedChange={onCheckedChange}
            >
                <Switch.Thumb className="block w-[20px] h-[20px] bg-white rounded-full shadow transition-transform translate-x-1 data-[state=checked]:translate-x-5" />
            </Switch.Root>
            <div
                onClick={() => onCheckedChange?.(!checked)}
                onKeyUp={() => onCheckedChange?.(!checked)}
                className={`text-white text-[14px] ${customLabelClass}`}
            >
                {label && (
                    <HoverTooltipText
                        text={label}
                        tooltipText={tooltipText}
                        className={tooltipText ? 'font-medium' : undefined}
                    />
                )}
            </div>
        </div>
    );
}
